export default "__VITE_PUBLIC_ASSET__6344702e__"